module.exports = __webpack_public_path__ + "static/logo.681dd1a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/logo.svg
// module id = 602
// module chunks = 114276838955818